export const DATE_FORMAT_OPTIONS = [
  "MM/DD/YYYY",
  "MM/DD/YY",
  "DD-MMM-YY",
  "DD-MMM-YYYY",
  "DD/MM/YYYY",
  "DD/MM/YY",
  "DD.MM.YY",
  "DD.MM.YYYY",
  "DD-MM-YYYY",
  "YYYY-MM-DD"
];

export const DATE_TIME_FORMAT_OPTIONS = [
  "DD-MMM-YY HH:mm",
  "DD-MMM-YYTHH:mmZ",
  "DD-MMM-YY hh:mm A",
  "DD-MMM-YYYY HH:mm",
  "DD-MMM-YYYY hh:mm A",
  "DD-MMM-YYYYTHH:mmZ",
  "DD/MM/YY HH:mm",
  "DD/MM/YYTHH:mmZ",
  "DD/MM/YY hh:mm A",
  "MM/DD/YY HH:mm",
  "MM/DD/YYTHH:mmZ",
  "MM/DD/YY hh:mm A",
  "MM/DD/YYYY HH:mm",
  "MM/DD/YYYYTHH:mmZ",
  "MM/DD/YYYY hh:mm A",
  "DD.MM.YY HH:mm",
  "DD.MM.YYTHH:mmZ",
  "DD.MM.YY hh:mm A",
  "DD.MM.YYYY HH:mm",
  "DD.MM.YYYYTHH:mmZ",
  "DD.MM.YYYY hh:mm A"
];
